export default {
    textConstants: {
        accordionDetailsLinkText: "Content panel link...",
        accordionMainPortalLinkText: "Main accordion link...",
        agentAssistErrorNotification: "Agent Assist is not available at this time. Please type in inputs manually.\n\nNote: Agent Assist is not compatible with Internet Explorer. Please use a different browser.",
        almeDisplayName: "Alme: ",
        authErrorResponse: 'Please try again later, unable to authenticate.',
        bannerText: "Intelligent Virtual Assistant",
        conversationAreaNewMessageButton: "New Messages",
        confirmText: "Are you sure you want to leave this page? Unsaved data may be lost.",
        dataCollectionFormatError: "Invalid format",
        dataCollectionRequiredError: "Required",
        dataCollectionRequiredTextDesc: "Required",
        displayLinksHeaderText: "More Information",
        defaultErrorResponse: "Please try again later, this service is currently down.",
        dropdownCancelText: "Cancel",
        dropdownSubmitText: "Submit",
        endChatWarningNoTitle: "No",
        endChatWarningText: "Are you sure you want to end your live chat session?",
        endChatWarningYesTitle: "Yes",
        helpButtonText: "Agent Help",
        inlineSurveyTitle: "Was this helpful?",
        inputboxDisabledPlaceholderText: "Please wait...",
        inputboxErrorText: "Please type a message to continue.",
        inputboxPlaceholderText: "Type your question here.",
        launchErrorResponse: "Please try again later, this service is currently down.",
        launchPointText: "Need Help?",
        linkFoldTitleText: "View more links",
        liveChatPendingPlaceholder: "Type here",
        minimizeWindowTitleText: "Minimize",
        moreLinksText: "More >>",
        pendingPlaceholder: "Please wait...",
        popperBody: "You're currently viewing this page",
        popperHeader: "Alert",
        selectLanguage: "Language: ",
        sendButtonTitleText: "Send your question",
        skipToContentLinkText: "Skip to End of Chat",
        skipToContentButtonTitle: "Skip to End of Chat",
        soundOffTitleText: "Turn sound off",
        soundOnTitleText: "Turn sound on",
        submitContent: "Send",
        submitKey: 'Enter',
        escapeKey: 'Escape',
        surveyCloseTitle: "Cancel Survey",
        timeoutWarningNoTitle: "No",
        timeoutWarningText: "Your session will expire in two minutes. Do you wish to continue?",
        timeoutWarningYesTitle: "Yes",
        userDisplayName: "You: ",
        viewPageLinkText: "View Page",
        calendarWidgetSundayText: "Sun",
        calendarWidgetMondayText: "Mon",
        calendarWidgetTuesdayText: "Tue",
        calendarWidgetWednesdayText: "Wed",
        calendarWidgetThursdayText: "Thu",
        calendarWidgetFridayText: "Fri",
        calendarWidgetSaturdayText: "Sat",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/text-constants.ts